import React from 'react';
import './css/Display3D.css';
import { animateVector3, animateQuaternion, animLib } from '../logic/animations';
import { Screen, HeaterScreen } from './Screens';
import * as THREE from 'three';
import * as TWEEN from '@tweenjs/tween.js';
window.THREE = THREE;

require( 'three/examples/js/loaders/GLTFLoader' );
require( 'three/examples/js/renderers/CSS3DRenderer.js' )
require( 'three/examples/js/controls/OrbitControls' );
require( 'three/examples/js/effects/OutlineEffect' );


class Display3D extends React.Component {

    constructor( props ) {

        super( props );

        this.state = { tutorialDone: false };

        this.cameraAngles = {

            "Scene": { position: new THREE.Vector3( 152.971, 44.195, 35.868 ), quat: new THREE.Quaternion( -0.1063, 0.615, 0.0841, 0.7767 ) },
            "NMR Control Tower": { position: new THREE.Vector3( 54.404, 26.53, -18.699 ), quat: new THREE.Quaternion( 0.0101, 0.7039, -0.0101, 0.71 ) },
            "NMR Chamber": { position: new THREE.Vector3( 41.404, 39.605, -44.994 ), quat: new THREE.Quaternion( -0.0079, 0.7146, 0.008, 0.6993 ) },
            "Master Power": { position: new THREE.Vector3( 22.347, 34.199, -72.503 ), quat: new THREE.Quaternion( -0.1596, 0.3153, 0.0538, 0.9339 ) },
            "Air Flow Controls": { position: new THREE.Vector3( -53.832, 45.545, -80.014 ), quat: new THREE.Quaternion( -0.0038, 0.018, 0, 0.9998 ) },
            "Galden Chiller": { position: new THREE.Vector3( 56.511, -23.976, -26.289 ), quat: new THREE.Quaternion( -0.0084, 0.7007, 0.0081, 0.7133 ) },
            "Water Chiller": { position: new THREE.Vector3( 54.344, -1.586, 62.622 ), quat: new THREE.Quaternion( -0.0282, 0.72, 0.0292, 0.6927 ) },
            "Computer": { position: new THREE.Vector3( 19.04, 30.805, 22.962 ), quat: new THREE.Quaternion( -0.1061, 0.701, 0.1066, 0.6971 ) },

        };
        this.hovered = {};

        document.addEventListener( "Reset", this.resetCamera );

    }

    componentDidMount() {

        //Scene
        this.scene = new THREE.Scene();
        this.scene.name = "Scene";
        this.scene.ReactData = this;
        this.scene.focused = this.scene;
        this.CSScene = new THREE.Scene();
        this.props.updateScene( this.scene );

        Object.defineProperties( this.scene, {
            "highlighted": {

                get: function () { return this._highlighted },

                set: function ( value ) {

                    this._highlighted && this._highlighted.material && this._highlighted.traverse( obj => {
                        obj.material.color.multiplyScalar( 2 );
                        if ( obj.material.opacity !== 1 ) obj.material.opacity = 0;
                        obj.material.emissive.r = 0
                    } );

                    value && value.traverse( obj => {
                        obj.material.color.multiplyScalar( 1 / 2 );
                        if ( obj.material.opacity !== 1 ) obj.material.opacity = 0.5;
                        obj.material.emissive.r = 0.5
                    } );

                    this._highlighted = value;
                    document.getElementById( "DisplayMouseover" ).innerHTML = value ? value.name : "";

                }

            }
        } )

        //Camera
        const renderBox = { width: Math.max( window.innerWidth * 0.6, 720 ), height: window.innerHeight };
        this.camera = new THREE.PerspectiveCamera( 70, renderBox.width / renderBox.height, 0.1, 1000 );
        this.scene.camera = this.camera;

        //Controls
        this.controls = new window.THREE.OrbitControls( this.camera, this.root );
        this.controls.enablePan = false;

        this.resetCamera();

        //EnvMap
        const loader = new THREE.CubeTextureLoader();
        loader.setPath( './img/' );
        const cubeTexture = loader.load( [ "cubemap.png", "cubemap.png", "cubemap.png", "cubemap.png", "cubemap.png", "cubemap.png" ] );
        cubeTexture.minFilter = THREE.NearestFilter;

        //Raycaster
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();

        //Geometry
        this.loader = new window.THREE.GLTFLoader();
        this.loader.load( 'NMR.glb', ( gltf ) => {

            const newScn = gltf.scene;
            newScn.traverse( obj => {

                if ( obj.type === "Mesh" ) {

                    const mat = new THREE.MeshPhysicalMaterial( {

                        color: obj.material.color,
                        vertexColors: obj.material.vertexColors,
                        reflectivity: 0,
                        roughness: 0.5,
                        envMap: cubeTexture,
                        envMapIntensity: 3,
                        aoMap: obj.material.aoMap,
                        aoMapIntensity: 0.6,
                        transparent: obj.material.name === "Transp",
                        opacity: obj.material.name === "Transp" ? ( obj.name === "Sample Tube STATIC" ? 0 : 0.5 ) : 1,
                        side: obj.material.name === "Transp" ? THREE.DoubleSide : THREE.FrontSide,

                    } );

                    obj.name = obj.name.replace( /_/g, " " );
                    if ( animLib.hasOwnProperty( obj.name ) ) obj.animation = animLib[ obj.name ];
                    obj.origPos = obj.position.clone();
                    obj.origQuat = obj.quaternion.clone();
                    obj.origMat = mat.clone();
                    obj.material = mat;

                    if ( this.cameraAngles.hasOwnProperty( obj.name ) ) { this.cameraAngles[ obj.name ].obj = obj }

                }

            } )
            this.scene.add( ...newScn.children );

            //Screen
            const addScreen = ( name, sizeX, sizeY, anchorName, screenDOMSelector, screenReact ) => {

                const screenMat = new THREE.MeshPhysicalMaterial( {

                    opacity: 0,
                    blending: THREE.NoBlending,
                    side: THREE.DoubleSide

                } );

                const screenDOM = document.querySelector( screenDOMSelector );
                screenDOM.style.width = sizeX + "px";
                screenDOM.style.height = sizeY + "px";
                const screenObj = new window.THREE.CSS3DObject( screenDOM );
                screenObj.name = name;
                screenObj.ReactData = screenReact;
                screenObj.scale.set( 0.02, 0.02, 0.02 );
                this.CSScene.add( screenObj );

                const screenAnchor = this.scene.getObjectByName( anchorName );
                screenAnchor.ReactData = screenReact;
                screenAnchor.material = screenMat;
                screenAnchor.origMat = screenMat;
                screenAnchor.parent.updateMatrixWorld();
                screenAnchor.getWorldPosition( screenObj.position );
                screenObj.quaternion.copy( screenAnchor.quaternion );

            }

            addScreen( "Screen", 1295, 845, "ScreenAnchor STATIC", ".component-screen", this.screen );
            addScreen( "HeaterScreen", 575, 300, "HeaterScreenAnchor STATIC", ".component-heaterscreen", this.heaterScreen );

            this.start();
            this.props.updateLoaded( true );

        }, undefined, ( err ) => { console.log( err ) } );

        //WebGLRenderer
        this.WebGL_Renderer = new THREE.WebGLRenderer( { antialias: true, alpha: true } );
        this.WebGL_Renderer.setSize( renderBox.width, renderBox.height );
        this.WebGL_Renderer.setClearColor( 0xFFFFFF, 0 );
        this.root.appendChild( this.WebGL_Renderer.domElement );

        //CSSRenderer
        this.CSS_Renderer = new window.THREE.CSS3DRenderer();
        this.CSS_Renderer.setSize( renderBox.width, renderBox.height );
        this.CSS_Renderer.domElement.style.position = "absolute";
        this.CSS_Renderer.domElement.style.top = "0px";
        this.CSS_Renderer.domElement.style.zIndex = "0";
        this.root.appendChild( this.CSS_Renderer.domElement );

        window.addEventListener( "resize", this.onResize );
        this.root.addEventListener( "mousemove", this.onMouseMove );
        this.root.addEventListener( "touchmove", this.onMouseMove );
        this.root.addEventListener( "touchstart", this.onMouseMove );
        this.root.addEventListener( "mousedown", this.onMouseDown );
        this.root.addEventListener( "touchstart", this.onMouseDown );
        this.root.addEventListener( "mouseout", () => this.scene.highlighted = null );

        document.addEventListener( "init", ev => {

            ev.detail.forEach( obj => {

                if ( this.scene.getObjectByName( obj ) ) {

                    this.scene.getObjectByName( obj ).animation( this.scene.getObjectByName( obj ), this.scene );

                }

            } )

        } )

    }

    componentWillUnmount() {

        this.stop();
        this.root.removeChild( this.WebGL_Renderer.domElement );
        this.root.removeChild( this.CSS_Renderer.domElement );
        this.scene.dispose();
        this.scene.dispose();
        window.removeEventListener( "resize", this.onResize );
        this.root.removeEventListener( "mousemove", this.onMouseMove );
        this.root.removeEventListener( "touchmove", this.onMouseMove );
        this.root.removeEventListener( "touchstart", this.onMouseMove );

    }

    onMouseDown = ev => {

        this.downPos = this.mouse.clone()
        document.addEventListener( "mouseup", this.onMouseUp );
        document.addEventListener( "touchend", this.onMouseUp );

    }

    onMouseUp = ev => {

        if ( !this.controls.enabled ) return;

        document.removeEventListener( "mouseup", this.onMouseUp );
        document.removeEventListener( "touchend", this.onMouseUp );

        if ( new THREE.Vector2().subVectors( this.downPos, this.mouse ).length() < 0.1 ) {

            document.dispatchEvent( new CustomEvent( "targetClicked", { detail: this.hovered } ) );

            if ( this.cameraAngles.hasOwnProperty( this.hovered.name ) ) {

                document.getElementById( "DisplayResetCamera" ).classList.remove( "Display_hidden" );

                if ( this.hovered.position ) this.controls.target.copy( this.hovered.position );
                this.animateCamera( this.hovered.name );
                this.scene.focused = this.hovered;
                this.scene.highlighted = null;
                this.hovered = {};

                if ( this.scene.focused.name === "NMR Control Tower" ) {
                    document.getElementsByClassName( "component-heaterscreen" )[ 0 ].style.pointerEvents = "unset";
                }

                if ( this.scene.focused.name === "Computer" ) {
                    document.getElementsByClassName( "component-screen" )[ 0 ].style.pointerEvents = "unset";
                    this.controls.enableZoom = false;
                    this.controls.enableRotate = false;
                }

            } else {

                this.animateCamera( this.scene.focused.name );

            }

        } else {

            this.animateCamera( this.scene.focused.name );

        }

    }

    fitScreen = () => {

        const boundSphere = new THREE.Box3().setFromObject( this.scene.getObjectByName( "ScreenAnchor STATIC" ) ).getBoundingSphere( new THREE.Sphere() );
        const distance = 1.2 * boundSphere.radius * 2 * Math.tan( this.camera.fov * Math.PI / 360 );
        return this.scene.getObjectByName( "Computer" ).position.clone().add( new THREE.Vector3( 0, 0, 1 ).applyQuaternion( this.cameraAngles[ "Computer" ].quat ).multiplyScalar( distance ) );


    }

    animateCamera = position => {

        if ( position === "Computer" ) {

            animateVector3( this.camera.position, this.fitScreen() );

        } else {

            animateVector3( this.camera.position, this.cameraAngles[ position ].position );

        }


        animateQuaternion( this.camera.quaternion, this.cameraAngles[ position ].quat );

    }

    resetCamera = () => {

        this.onResize();

        document.getElementById( "DisplayResetCamera" ).classList.add( "Display_hidden" );
        this.animateCamera( "Scene" );
        document.getElementsByClassName( "component-screen" )[ 0 ].style.pointerEvents = "none";
        document.getElementsByClassName( "component-heaterscreen" )[ 0 ].style.pointerEvents = "none";
        this.controls.enableZoom = true;
        this.controls.enableRotate = true;
        this.controls.enabled = true;
        this.controls.target.set( 0.126, 0.426, -0.151 );
        this.scene.focused = this.scene;

    }

    onMouseMove = ev => {

        const renderBox = this.WebGL_Renderer.getSize();

        if ( ev.touches ) {

            ev.pageX = ev.touches[ 0 ].pageX;
            ev.pageY = ev.touches[ 0 ].pageY;

        }

        this.mouse.set(
            ( ev.pageX / renderBox.width ) * 2 - 1,
            - ( ev.pageY / renderBox.height ) * 2 + 1
        )

        const rc = this.raycaster;
        rc.setFromCamera( this.mouse, this.camera );
        let mouseover = rc.intersectObjects( this.scene.children, true )[ 0 ];

        this.scene.highlighted = null;
        this.hovered = {};

        if ( mouseover ) { mouseover = mouseover.object }
        else { return }

        mouseover = mouseover.parent.type === "Mesh" && this.scene.focused !== mouseover.parent ? mouseover.parent : mouseover;

        if ( mouseover.type === "Mesh" && !mouseover.name.includes( "STATIC" ) && mouseover !== this.scene.focused ) {

            this.scene.highlighted = mouseover;
            this.hovered = mouseover;

        }

    }

    onResize = () => {

        if ( !this.WebGL_Renderer ) { return }
        const renderBox = this.root.getBoundingClientRect();
        if ( this.WebGL_Renderer.getSize().width === renderBox.width && this.WebGL_Renderer.getSize().height === renderBox.height ) return;

        this.CSS_Renderer.setSize( renderBox.width, renderBox.height );
        this.WebGL_Renderer.setSize( renderBox.width, renderBox.height );
        this.camera.aspect = renderBox.width / renderBox.height;
        this.camera.updateProjectionMatrix();

    }

    animate = time => {

        TWEEN.update( time );

        this.CSS_Renderer.render( this.CSScene, this.camera );
        this.WebGL_Renderer.render( this.scene, this.camera );
        this.frameId = requestAnimationFrame( this.animate );

    }

    start = () => {

        this.frameId = this.frameId || requestAnimationFrame( this.animate );

    }

    stop = () => {

        cancelAnimationFrame( this.frameId );

    }

    render() {
        return (

            <div ref={ mount => this.root = mount } className={ `Display` }>
                <p id="DisplayMouseover"></p>
                <button id="DisplayResetCamera" type="button" onClick={ this.resetCamera }>Return to Full View</button>
                <Screen ref={ mount => this.screen = mount } />
                <HeaterScreen ref={ mount => this.heaterScreen = mount } />
            </div>

        );
    }
}


export default Display3D;
